import { Close } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';

const CloseModalIcon = ({
  onHide,
  title
}: {
  onHide: () => void;
  title?: string;
}) => {
  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 10
      }}
    >
      <Box>{!!title && <Typography variant="h4">{title}</Typography>}</Box>
      <IconButton onClick={onHide}>
        <Close color="error" />
      </IconButton>
    </Box>
  );
};

export default CloseModalIcon;
